import React from "react";
import CoverContainer from "views/UserProfile/CoverContainer/CoverContainer";
import UserAvatar from "views/UserProfile/UserAvatar/UserAvatar";
import UserNameAndMood from "views/UserProfile/UserNameAndMood/UserNameAndMood";

export default ({ userProfile, setUserProfile, isOwner }) => {
  return (
    <>
      <CoverContainer
        profile={userProfile}
        setProfile={setUserProfile}
        isOwner={isOwner}
      ></CoverContainer>
      <div style={{ position: "relative" }}>
        <UserAvatar
          profile={userProfile}
          setProfile={setUserProfile}
          isOwner={isOwner}
        />
        <UserNameAndMood
          profile={userProfile}
          setProfile={setUserProfile}
          isOwner={isOwner}
        />
      </div>
    </>
  );
};
